import React from "react";

import moment from "moment";
import StatusChip from "../components/StatusChip";
import Date from "../components/Date";
import ToolTipText from "../components/ToolTipText";
export const REWARD_TYPES = {
  PAYMENTS: 0,
  XOXO_POINTS: 1,
  XOXO_CODE: 2,
  XOXO_LINK: 3,
  PLUM_PRO: 4,
};
export const MULTI_ADMIN_STATUS_PAYMENTS = [
  {
    label: "Complete",
    value: "Complete",
  },
  {
    label: "Finance Pending",
    value: "Finance pending",
  },
];
export const PAYMENTS_REASONS = [
  {
    label: "Distributed Xoxo Points",
    value: "Distributed Xoxo Points",
  },
  {
    label: "Distributed Xoxo Codes",
    value: "Distributed Xoxo Codes",
  },
  {
    label: "Refund Issued",
    value: "Refund Issued",
  },
  {
    label: "Distributed Xoxo Links",
    value: "Distributed Xoxo Links",
  },
  {
    label: "Xoxo Links Redemption",
    value: "Xoxo Links Redemption",
  },
  {
    label: "Funds Addition",
    value: "Funds Addition",
  },
  {
    label: "Brand Vouchers issued",
    value: "Brand Vouchers issued",
  },
];

export const MULTI_ADMIN_PAYMENT_REPORT_TABLE_CONST_KEYS = [
  {
    name: "invoice",
    label: "Invoice",
    defaultChecked: true,
    options: {
      sort: false,
    },
    filter: {
      filterType: "input",
      filters: [
        {
          operation: "contains",
          value: "",
          selected: true,
          key: "invoice",
        },
      ],
    },
  },
  {
    name: "payment_reference_id",
    label: "Payment Reference ID",
    value: "Payment Reference ID",
    options: {
      setCellHeaderProps: () => ({ className: "text-right mr-0" }),
      setCellProps: () => ({
        className: "text-right",
        style: {
          whiteSpace: "nowrap",
        },
      }),
      sort: false,
    },
    filter: {
      filterType: "input",
      filters: [
        {
          operation: "is",
          value: "",
          selected: true,
          key: "payment_reference_id",
        },
      ],
    },
  },
  {
    name: "date_added",
    label: "Date (UTC)",
    defaultChecked: true,
    options: {
      sort: false,
      customBodyRender: (value) => {
        return (
          <span
            style={{
              whiteSpace: "nowrap",
            }}
          >
            {moment(value, "YYYY-MM-DD").format("MMM D, YYYY")}
          </span>
        );
      },
      display: true,
    },
    filter: {
      filterType: "date",
      filters: {
        operation: "IS BETWEEN",
        startDate: moment().subtract(1, "month").format("YYYY-MM-DD"),
        endDate: moment().format("YYYY-MM-DD"),
        selected: true,
      },
    },
  },
  {
    name: "reason",
    label: "Reason",
    defaultChecked: true,
    options: {
      sort: false,
      customBodyRender: (value) => {
        return (
          <span
            style={{
              whiteSpace: "nowrap",
            }}
          >
            {value}
          </span>
        );
      },
    },
    filter: {
      filterType: "select",
      filters: {
        value: "",
        options: PAYMENTS_REASONS,
        operation: "is",
      },
    },
  },
  {
    name: "status",
    label: "Status",
    defaultChecked: true,
    options: {
      sort: false,
      customBodyRender: (value, tableMeta, updateValue) => {
        return <StatusChip value={value} />;
      },
      setCellProps: () => ({
        style: {
          textAlign: "center",
        },
      }),
      setCellHeaderProps: () => ({
        style: {
          textAlign: "center",
        },
      }),
    },
    filter: {
      filterType: "select",
      filters: {
        value: "",
        options: MULTI_ADMIN_STATUS_PAYMENTS,
        operation: "IS",
      },
    },
  },
  {
    name: "changed_balance",
    label: "Adjusted amount",
    value: "Adjusted amount",
    options: {
      sort: false,
      setCellHeaderProps: () => ({ className: "text-right mr-0" }),
      setCellProps: () => ({ className: "text-right" }),
      customBodyRender: (value) => {
        return parseFloat(value)?.toLocaleString();
      },
    },
    filter: {
      filterType: "inputNumber",
      filters: [
        {
          operation: "is lesser than or equals",
          value: "",
          selected: true,
          key: "changed_balance_max",
        },
        {
          operation: "is greater than or equals",
          value: "",
          selected: false,
          key: "changed_balance_min",
        },
      ],
    },
  },
  {
    name: "closing_balance",
    label: "Closing Balance",
    value: "Closing Balance",
    options: {
      sort: false,
      setCellHeaderProps: () => ({ className: "text-right mr-0" }),
      setCellProps: () => ({ className: "text-right" }),
      customBodyRender: (value) => {
        return parseFloat(value)?.toLocaleString();
      },
    },
  },
  // {
  //   name: "type",
  //   label: "Type",
  //   value: "Type",
  //   filter: {
  //     filterType: "",
  //     filters: [
  //       {
  //         operation: "contains",
  //         value: "",
  //         selected: true,
  //       },
  //     ],
  //   },
  // },

  {
    name: "action",
    label: " ",
    defaultChecked: true,
    options: {
      sort: false,
    },
  },
];

export const MULTI_ADMIN_STATUS_XOXO_CODE = [
  {
    label: "Redeemed",
    value: "Redeemed",
  },
  // {
  //     label : "Unredeemed",
  //     value : "Unredeemed"
  // },
  {
    label: "Partially Redeemed",
    value: "Partially Redeemed",
  },
  // {
  //     label : "Expired",
  //     value : "Expired"
  // },
  {
    label: "Cancelled",
    value: "Cancelled",
  },
  {
    label: "Delivered",
    value: "Delivered",
  },
  {
    label: "Not Delivered",
    value: "Not Delivered",
  },
];

export const MULTI_ADMIN_POINTS_REPORT_TABLE_CONST_KEYS = [
  {
    name: "unique_id",
    label: "Unique ID",
    value: "unique_id",
    defaultChecked: true,
    checked: true,
    search: false,
    options: {
      sort: false,
    },
    filter: {
      filterType: "input",
      filters: [
        { operation: "is", value: "", selected: true, key: "unique_id" },
      ],
    },
  },
  {
    name: "payment_reference_id",
    label: "Payment Reference ID",
    value: "payment_reference_id",
    defaultChecked: true,
    checked: true,
    search: false,
    options: {
      sort: false,
    },
    filter: {
      filterType: "input",
      filters: [
        {
          operation: "is",
          value: "",
          selected: true,
          key: "payment_reference_id",
        },
      ],
    },
  },
  {
    label: "Recipient Name",
    value: "receiver_name",
    name: "receiver_name",
    defaultChecked: true,
    checked: true,
    search: true,
    sort: true,
    sort_Type: "",
    searchKey: "name",
    filter: {
      filterType: "input",
      filters: [
        { operation: "is", value: "", selected: true, key: "name_is" },
        { operation: "contains", value: "", selected: false, key: "name_like" },
      ],
    },
    options: {
      setCellProps: () => ({
        style: { maxWidth: "250px", whiteSpace: "nowrap" },
      }),
      customBodyRender: (value) => {
        return <ToolTipText value={value} />;
      },
    },
  },
  {
    label: "Recipient Email",
    value: "receiver_email",
    name: "receiver_email",
    defaultChecked: true,
    checked: true,
    search: true,
    options: {
      sort: false,
      setCellProps: () => ({
        style: { maxWidth: "250px", whiteSpace: "nowrap" },
      }),
      customBodyRender: (value) => {
        return <ToolTipText value={value} />;
      },
    },
    searchKey: "email",
    filter: {
      filterType: "input",
      filters: [
        {
          operation: "is",
          value: "",
          selected: true,
          key: "email_is",
        },
      ],
    },
  },
  {
    label: "Recipient Phone",
    value: "receiver_phone_number",
    name: "receiver_phone_number",
    defaultChecked: true,
    checked: true,
    search: true,
    sort: false,
    searchKey: "receiver_phone_number",
    filter: {
      filterType: "inputNumber",
      filters: [
        {
          operation: "is",
          value: "",
          selected: true,
          key: "receiver_phone_number",
        },
      ],
    },
    options: {
      display: false,
    },
  },
  {
    label: "Point Sent",
    value: "total_amount_with_currency",
    name: "total_amount_with_currency",
    defaultChecked: true,
    checked: true,
    search: false,
    options: {
      sort: false,
      setCellHeaderProps: () => ({ className: "text-right" }),
      setCellProps: () => ({ className: "text-right" }),
    },
    filter: {
      filterType: "inputNumber",
      filters: [
        {
          operation: "is lesser than or equals",
          value: "",
          selected: true,
          key: "max_amount",
        },
        {
          operation: "is greater than or equals",
          value: "",
          selected: false,
          key: "min_amount",
        },
        // {operation : "is between",min_amount : "",max_amount : "",selected : true},
      ],
    },
  },
  {
    label: "Points Redeemed",
    value: "used_amount_with_currency",
    name: "used_amount_with_currency",
    defaultChecked: false,
    checked: false,
    search: false,
    options: {
      display: false,
      sort: false,
      setCellHeaderProps: () => ({ className: "text-right" }),
      setCellProps: () => ({ className: "text-right" }),
    },
  },
  {
    label: "Sent Date (UTC)",
    value: "generation_date",
    name: "generation_date",
    defaultChecked: true,
    checked: true,
    search: false,
    sort: true,
    sort_Type: "desc",
    filter: {
      filterType: "date",
      filters: {
        operation: "is between",
        startDate: moment().subtract(1, "month").format("YYYY-MM-DD"),
        endDate: moment().format("YYYY-MM-DD"),
        selected: true,
      },
    },
    options: {
      customBodyRender: (value) => {
        return <Date value={value} />;
      },
    },
  },
  // {
  //     "label" : "Date expiry",
  //     "value" : 'expiry_date',
  //     "defaultChecked" : false,
  //     'checked' : false,
  //     'search' : false,
  //     'sort' : false,
  //     filter : {
  //         "filterType" : "date",
  //         "filters" : {
  //             operation : "is between",
  //             startDate : "",
  //             endDate : "",
  //             selected : true
  //         }
  //     }
  // },
  {
    label: "Last Redeemed On (UTC)",
    value: "last_redemeed",
    name: "last_redemeed",
    defaultChecked: false,
    checked: false,
    search: false,
    sort: true,
    sort_Type: "",
    options: {
      display: false,
      customBodyRender: (value) => {
        return <Date value={value} />;
      },
    },
    filter: {
      filterType: "date",
      filters: {
        operation: "is between",
        startDate: "",
        endDate: "",
        selected: true,
      },
    },
  },
  {
    label: "Status",
    value: "status",
    name: "status",
    defaultChecked: true,
    checked: true,
    search: false,
    sort: true,
    sort_Type: "",
    options: {
      setCellHeaderProps: () => ({
        className: "text-center column-name-center",
      }),
      customBodyRender: (value, tableMeta, updateValue) => {
        return <StatusChip value={value} />;
      },
    },
    filter: {
      filterType: "select",
      filters: {
        value: "",
        options: MULTI_ADMIN_STATUS_XOXO_CODE,
        operation: "is",
      },
    },
  },
  {
    label: "Mode of Delivery",
    value: "mode_of_delivery",
    name: "mode_of_delivery",
    defaultChecked: false,
    checked: false,
    options: {
      display: false,
    },
  },
  {
    label: "Sent By",
    value: "sent_by",
    name: "sent_by",
    defaultChecked: false,
    checked: false,
    search: false,
    options: {
      display: false,
      sort: false,
    },
    filter: {
      filterType: "select",
      filters: {
        value: "",
        options: [],
        operation: "is",
      },
    },
  },
  {
    label: "Notes",
    value: "notes",
    name: "notes",
    defaultChecked: false,
    checked: false,
    search: false,
    options: {
      sort: false,
      display: false,
      setCellProps: () => ({
        style: {
          maxWidth: "300px",
          whiteSpace: "nowrap",
          wordWrap: "break-word",
        },
      }),
      customBodyRender: (value) => {
        return <ToolTipText value={value} />;
      },
    },
    filter: {
      filterType: "input",
      filters: [
        { operation: "is", value: "", selected: true, key: "notes_is" },
        {
          operation: "contains",
          value: "",
          selected: false,
          key: "notes_like",
        },
      ],
    },
  },
  {
    name: "action",
    label: " ",
    defaultChecked: true,
    options: {
      sort: false,
    },
  },
];
export const XOXO_POINT_SCHEDULER_CONSTANT = [
  {
    label: "Name",
    name: "name",
    defaultChecked: true,
    options: {
      sort: false,
      setCellProps: () => ({
        style: { maxWidth: "250px", whiteSpace: "nowrap" },
      }),
      customBodyRender: (value) => {
        return <ToolTipText value={value} />;
      },
    },
  },
  {
    label: "Email",
    name: "email",
    defaultChecked: true,
    options: {
      sort: false,
      setCellProps: () => ({
        style: { maxWidth: "250px", whiteSpace: "nowrap" },
      }),
      customBodyRender: (value) => {
        return <ToolTipText value={value} />;
      },
    },
  },
  {
    label: "Phone Number",
    name: "phone_no",
    defaultChecked: true,
    options: {
      sort: false,
    },
  },
  {
    label: "Amount",
    name: "amount",
    defaultChecked: true,
    options: {
      sort: false,
      setCellHeaderProps: () => ({ className: "text-right" }),
      setCellProps: () => ({ className: "text-right" }),
    },
  },
  {
    label: "Schedule Date (UTC)",
    name: "schedule_date",
    defaultChecked: false,
    checked: true,
    options: {
      sort: false,
      customBodyRender: (value) => {
        return <Date value={value} />;
      },
    },
  },
  {
    label: "Notes",
    name: "notes",
    defaultChecked: true,
    options: {
      sort: false,
      setCellProps: () => ({
        style: { maxWidth: "250px", whiteSpace: "nowrap" },
      }),
      customBodyRender: (value) => {
        return <ToolTipText value={value} />;
      },
    },
  },
  {
    label: "Status",
    name: "status",
    defaultChecked: false,
    options: {
      sort: false,
      customBodyRender: (value, tableMeta, updateValue) => {
        return (
          <StatusChip
            value={value === 2 ? "Scheduled" : "Cancelled"}
            color={value === 2 ? "primary" : "error"}
          />
        );
      },
    },
  },
  {
    name: "action",
    label: " ",
    defaultChecked: true,
    options: {
      sort: false,
    },
  },
];

export const MULTI_ADMIN_XOXO_CODE_REPORT_TABLE_CONST_KEYS = [
  {
    name: "unique_id",
    label: "Unique ID",
    value: "unique_id",
    defaultChecked: true,
    checked: true,
    search: false,
    options: {
      sort: false,
    },
    filter: {
      filterType: "input",
      filters: [
        { operation: "is", value: "", selected: true, key: "unique_id" },
      ],
    },
  },
  {
    name: "payment_reference_id",
    label: "Payment Reference ID",
    value: "payment_reference_id",
    defaultChecked: true,
    checked: true,
    search: false,
    options: {
      sort: false,
    },
    filter: {
      filterType: "input",
      filters: [
        {
          operation: "is",
          value: "",
          selected: true,
          key: "payment_reference_id",
        },
      ],
    },
  },
  {
    label: "Recipient Name",
    value: "receiver_name",
    name: "receiver_name",
    defaultChecked: true,
    checked: true,
    search: true,
    sort: true,
    sort_Type: "",
    searchKey: "name",
    filter: {
      filterType: "input",
      filters: [
        { operation: "is", value: "", selected: true, key: "name_is" },
        { operation: "contains", value: "", selected: false, key: "name_like" },
      ],
    },
    options: {
      setCellProps: () => ({
        style: { maxWidth: "250px", whiteSpace: "nowrap" },
      }),
      customBodyRender: (value) => {
        return <ToolTipText value={value} />;
      },
    },
  },
  {
    label: "Recipient Email",
    value: "receiver_email",
    name: "receiver_email",
    defaultChecked: true,
    checked: true,
    search: true,
    options: {
      sort: false,
      setCellProps: () => ({
        style: { maxWidth: "250px", whiteSpace: "nowrap" },
      }),
      customBodyRender: (value) => {
        return <ToolTipText value={value} />;
      },
    },
    searchKey: "email",
    filter: {
      filterType: "input",
      filters: [
        {
          operation: "is",
          value: "",
          selected: true,
          key: "email_is",
        },
      ],
    },
  },
  // {
  // 	"label" : "Phone Code",
  //     "value" :  "receiver_phone_code",
  //     "defaultChecked" : false,
  //     "checked" : false
  // },
  {
    label: "Recipient Phone",
    value: "receiver_phone_number",
    name: "receiver_phone_number",
    defaultChecked: true,
    checked: true,
    search: true,
    options: {
      sort: false,
      display: false,
    },
    searchKey: "receiver_phone_number",
    filter: {
      filterType: "inputNumber",
      filters: [
        {
          operation: "is",
          value: "",
          selected: true,
          key: "receiver_phone_number",
        },
      ],
    },
  },
  // {
  //     "label" : "Used",
  //     "value" : 'used_amount_with_currency',
  //     "defaultChecked" : false,
  //     'checked' : false,
  //     'search' : false,
  //     'sort' : false,
  //     // filter : {
  //     //     "filterType" : "inputNumber",
  //     //     "filters" : [{
  //     //         operation : "is between",
  //     //         value1 : "",
  //     //         value2 : "",
  //     //         selected : true
  //     //     }]
  //     // }
  // },
  {
    label: "Value of Code",
    value: "total_amount_with_currency",
    name: "total_amount_with_currency",
    defaultChecked: true,
    checked: true,
    search: false,
    sort: false,
    options: {
      sort: false,
      setCellHeaderProps: () => ({ className: "text-right mr-0" }),
      setCellProps: () => ({ className: "text-right" }),
    },
    filter: {
      filterType: "inputNumber",
      filters: [
        {
          operation: "is lesser than or equals",
          value: "",
          selected: true,
          key: "max_amount",
        },
        {
          operation: "is greater than or equals",
          value: "",
          selected: false,
          key: "min_amount",
        },
        // {operation : "is between",min_amount : "",max_amount : "",selected : true},
      ],
    },
  },
  {
    label: "Redeemed",
    value: "used_amount_with_currency",
    name: "used_amount_with_currency",
    defaultChecked: false,
    checked: false,
    search: false,
    options: {
      display: false,
      sort: false,
      setCellHeaderProps: () => ({ className: "text-right mr-0" }),
      setCellProps: () => ({ className: "text-right" }),
    },
    key: "Redeemed",
  },
  {
    label: "Sent Date (UTC)",
    value: "generation_date",
    name: "generation_date",
    defaultChecked: true,
    checked: true,
    search: false,
    sort: true,
    sort_Type: "desc",
    options: {
      sort: true,
      customBodyRender: (value) => {
        return <Date value={value} />;
      },
    },
    filter: {
      filterType: "date",
      filters: {
        operation: "is between",
        startDate: moment().subtract(1, "month").format("YYYY-MM-DD"),
        endDate: moment().format("YYYY-MM-DD"),
        selected: true,
      },
    },
  },
  // {
  //     "label" : "Date expiry",
  //     "value" : 'expiry_date',
  //     "defaultChecked" : false,
  //     'checked' : false,
  //     'search' : false,
  //     'sort' : false,
  //     filter : {
  //         "filterType" : "date",
  //         "filters" : {
  //             operation : "is between",
  //             startDate : "",
  //             endDate : "",
  //             selected : true
  //         }
  //     }
  // },
  {
    label: "Last Redeemed On (UTC)",
    value: "last_redemeed",
    name: "last_redemeed",
    defaultChecked: false,
    checked: false,
    search: false,
    sort: true,
    options: {
      display: false,
      customBodyRender: (value) => {
        return <Date value={value} />;
      },
    },
    sort_Type: "",
    filter: {
      filterType: "date",
      filters: {
        operation: "is between",
        startDate: "",
        endDate: "",
        selected: true,
      },
    },
  },
  {
    label: "Status",
    value: "status",
    name: "status",
    defaultChecked: true,
    checked: true,
    search: false,
    sort: true,
    sort_Type: "",
    options: {
      setCellHeaderProps: () => ({
        className: "column-name-center",
      }),
      customBodyRender: (value, tableMeta, updateValue) => {
        return <StatusChip value={value} />;
      },
    },
    filter: {
      filterType: "select",
      filters: {
        value: "",
        options: MULTI_ADMIN_STATUS_XOXO_CODE,
        operation: "is",
      },
    },
  },
  {
    label: "Campaign",
    value: "campaign_name",
    name: "campaign_name",
    defaultChecked: false,
    checked: false,
    search: false,
    options: {
      sort: false,
      display: false,
      setCellProps: () => ({
        style: { whiteSpace: "nowrap" },
      }),
    },
    filter: {
      filterType: "select",
      filters: {
        value: "",
        options: [],
        operation: "is",
      },
    },
  },
  {
    label: "Mode of Delivery",
    value: "mode_of_delivery",
    name: "mode_of_delivery",
    defaultChecked: false,
    checked: false,
    options: {
      sort: false,
      display: false,
    },
  },
  {
    label: "Sent By",
    value: "sent_by",
    name: "sent_by",
    defaultChecked: false,
    checked: false,
    search: false,
    options: {
      sort: false,
      display: false,
    },
    filter: {
      filterType: "select",
      filters: {
        value: "",
        options: [],
        operation: "is",
      },
    },
  },
  {
    label: "Notes",
    value: "notes",
    name: "notes",
    defaultChecked: false,
    checked: false,
    search: false,
    options: {
      sort: false,
      display: false,
      setCellProps: () => ({
        style: { maxWidth: "250px", whiteSpace: "nowrap" },
      }),
      customBodyRender: (value) => {
        return <ToolTipText value={value} />;
      },
    },
    filter: {
      filterType: "input",
      filters: [
        { operation: "is", value: "", selected: true, key: "notes_is" },
        {
          operation: "contains",
          value: "",
          selected: false,
          key: "notes_like",
        },
      ],
    },
  },
  {
    label: "Xoxo Code",
    value: "voucher_code",
    name: "voucher_code",
    defaultChecked: true,
    checked: true,
    options: {
      sort: false,
    },
  },
  {
    name: "action",
    label: " ",
    defaultChecked: true,
    options: {
      sort: false,
    },
  },
];
export const XOXO_CODE_SCHEDULER_CONSTANT = [
  {
    label: "Name",
    name: "name",
    defaultChecked: true,
    checked: true,
    options: {
      sort: false,
      setCellProps: () => ({
        style: { maxWidth: "250px", whiteSpace: "nowrap" },
      }),
      customBodyRender: (value) => {
        return <ToolTipText value={value} />;
      },
    },
  },
  {
    label: "Email",
    name: "email",
    defaultChecked: true,
    checked: true,
    options: {
      sort: false,
      setCellProps: () => ({
        style: { maxWidth: "250px", whiteSpace: "nowrap" },
      }),
      customBodyRender: (value) => {
        return <ToolTipText value={value} />;
      },
    },
  },
  {
    label: "Phone Number",
    name: "phone_no",
    defaultChecked: true,
    checked: true,
  },
  {
    label: "Amount",
    name: "denomination",
    defaultChecked: true,
    checked: true,
    options: {
      sort: false,
      display: true,
      setCellHeaderProps: () => ({ className: "text-right" }),
      setCellProps: () => ({ className: "text-right" }),
    },
  },
  {
    label: "Quantity",
    name: "quantity",
    defaultChecked: true,
    checked: true,
    options: {
      sort: false,
      display: true,
      setCellHeaderProps: () => ({ className: "text-right" }),
      setCellProps: () => ({ className: "text-right" }),
    },
  },
  {
    label: "Schedule Date (UTC)",
    name: "schedule_date",
    defaultChecked: false,
    checked: true,
    options: {
      customBodyRender: (value) => {
        return <Date value={value} />;
      },
    },
  },
  {
    label: "Notes",
    name: "notes",
    defaultChecked: true,
    checked: true,
    options: {
      sort: false,
      setCellProps: () => ({
        style: { maxWidth: "250px", whiteSpace: "nowrap" },
      }),
      customBodyRender: (value) => {
        return <ToolTipText value={value} />;
      },
    },
  },
  {
    label: "Status",
    name: "status",
    defaultChecked: false,
    checked: true,
    options: {
      customBodyRender: (value, tableMeta, updateValue) => {
        return <StatusChip value={value} />;
      },
    },
  },
  { label: " ", name: "action" },
];
export const XOXO_LINK_STATUS_SEND_TO_SELF = [
  {
    label: "Delivered",
    value: "delivered",
  },
  {
    label: "Redeemed",
    value: "redeemed",
  },
  {
    label: "Cancelled",
    value: "cancelled",
  },
  {
    label: "Not Delivered",
    value: "not_delivered",
  },
];

export const XOXO_LINK_MODE_DELIVERY = [
  {
    label: "Email",
    value: "Email",
    valueSend: "1",
  },
  {
    label: "Sms",
    value: "Sms",
    valueSend: "2",
  },
  {
    label: "Both",
    value: "Both",
    valueSend: "3",
  },
];
export const XOXO_LINK_SENT_TO_SELF_KEYS = [
  {
    name: "unique_id",
    label: "Unique ID",
    value: "unique_id",
    defaultChecked: true,
    checked: true,
    search: false,
    options: {
      sort: false,
    },
    filter: {
      filterType: "input",
      filters: [
        { operation: "is", value: "", selected: true, key: "unique_id" },
      ],
    },
  },
  {
    name: "payment_reference_id",
    label: "Payment Reference ID",
    value: "payment_reference_id",
    defaultChecked: true,
    checked: true,
    search: false,
    options: {
      sort: false,
    },
    filter: {
      filterType: "input",
      filters: [
        {
          operation: "is",
          value: "",
          selected: true,
          key: "payment_reference_id",
        },
      ],
    },
  },
  {
    label: "Recipient Name",
    value: "recipient_name",
    name: "recipient_name",
    defaultChecked: true,
    checked: true,
    search: true,
    sort: true,
    searchKey: "name",
    sort_Type: "",
    filter: {
      filterType: "input",
      filters: [
        { operation: "contains", value: "", selected: true, key: "name" },
      ],
    },
  },
  {
    label: "Recipient Email",
    value: "recipient_email",
    name: "recipient_email",
    defaultChecked: true,
    checked: true,
    search: true,
    sort: false,
    options: {
      sort: false,
    },
    filter: {
      filterType: "input",
      filters: [
        {
          operation: "is",
          value: "",
          selected: true,
          key: "emailId",
        },
      ],
    },
  },
  {
    label: "Value of Link",
    value: "denomination_value",
    name: "denomination_value",
    defaultChecked: true,
    checked: true,
    search: false,
    options: {
      sort: false,
    },
  },
  {
    label: "Sent Date (UTC)",
    value: "issued_date",
    name: "issued_date",
    defaultChecked: true,
    checked: true,
    search: false,
    sort: true,
    sort_Type: "desc",
    filter: {
      filterType: "date",
      filters: {
        operation: "is between",
        startDate: moment().subtract(1, "month").format("YYYY-MM-DD"),
        endDate: moment().format("YYYY-MM-DD"),
        selected: true,
      },
    },
    options: {
      customBodyRender: (value) => {
        return <Date value={value} />;
      },
    },
  },
  {
    label: "Redemption Date (UTC)",
    value: "redemption_date",
    name: "redemption_date",
    defaultChecked: false,
    checked: false,
    filter: {
      filterType: "date",
      filters: {
        operation: "is between",
        startDate: "",
        endDate: "",
        selected: true,
      },
    },
    options: {
      sort: false,
      display: false,
      customBodyRender: (value) => {
        return <Date value={value} />;
      },
    },
  },
  {
    label: "Expiry Date (UTC)",
    value: "issued_date",
    name: "expiry_date",
    defaultChecked: false,
    checked: false,
    search: false,
    options: {
      sort: false,
      display: false,
      customBodyRender: (value) => {
        return <Date value={value} />;
      },
    },
  },
  {
    label: "Redeemed By",
    value: "redemption_by",
    name: "redemption_by",
    defaultChecked: false,
    checked: false,
    options: {
      sort: false,
      display: false,
      customBodyRender: (value) => {
        return (
          <span
            style={{
              whiteSpace: "nowrap",
            }}
          >
            {value}
          </span>
        );
      },
    },
  },
  {
    label: "Status",
    value: "redemption_status",
    name: "redemption_status",
    defaultChecked: true,
    checked: true,
    search: false,
    sort: true,
    sort_Type: "",
    options: {
      customBodyRender: (value, tableMeta, updateValue) => {
        return <StatusChip value={value} />;
      },
    },
    filter: {
      filterType: "select",
      filters: {
        value: "",
        options: XOXO_LINK_STATUS_SEND_TO_SELF,
        operation: "is",
      },
    },
  },
  {
    label: "Campaign",
    value: "campaignName",
    name: "campaignName",
    defaultChecked: false,
    checked: false,
    search: false,
    options: {
      sort: false,
      display: false,
    },
    filter: {
      filterType: "select",
      filters: {
        value: "",
        options: [],
        operation: "is",
      },
    },
  },

  {
    label: "Sent By",
    value: "sent_byemail",
    name: "sent_byemail",
    defaultChecked: false,
    checked: false,
    search: false,
    options: {
      sort: false,
      display: false,
    },
  },
  {
    label: "Batch ID",
    value: "batchId",
    name: "batchId",
    defaultChecked: true,
    checked: true,
    filter: {
      filterType: "input",
      filters: [
        {
          operation: "is",
          value: "",
          selected: true,
          key: "batchId",
        },
      ],
    },
    key: "batchId",
    options: {
      sort: false,
    },
  },
  {
    label: "Xoxo Link",
    value: "xoxolink",
    name: "xoxolink",
    defaultChecked: false,
    checked: false,
    options: {
      sort: false,
      display: false,
    },
  },
  {
    label: "Notes",
    value: "notes",
    name: "notes",
    defaultChecked: false,
    checked: false,
    options: {
      sort: false,
      display: false,
      setCellProps: () => ({
        style: { maxWidth: "250px", whiteSpace: "nowrap" },
      }),
      customBodyRender: (value) => {
        return <ToolTipText value={value} />;
      },
    },
  },
  { label: " ", name: "action" },
];

export const XOXO_LINK_STATUS_SEND_TO_FEW = [
  {
    label: "Delivered",
    value: "delivered",
  },
  {
    label: "Redeemed",
    value: "redeemed",
  },
  {
    label: "Cancelled",
    value: "cancelled",
  },
  {
    label: "Not Delivered",
    value: "not_delivered",
  },
];

export const XOXO_LINK_DISTRIBUTED_TABLE_KEYS = [
  {
    name: "unique_id",
    label: "Unique ID",
    value: "unique_id",
    defaultChecked: true,
    checked: true,
    search: false,
    options: {
      sort: false,
    },
    filter: {
      filterType: "input",
      filters: [
        { operation: "is", value: "", selected: true, key: "unique_id" },
      ],
    },
  },
  {
    name: "payment_reference_id",
    label: "Payment Reference ID",
    value: "payment_reference_id",
    defaultChecked: true,
    checked: true,
    search: false,
    options: {
      sort: false,
    },
    filter: {
      filterType: "input",
      filters: [
        {
          operation: "is",
          value: "",
          selected: true,
          key: "payment_reference_id",
        },
      ],
    },
  },
  {
    label: "Recipient Name",
    value: "recipient_name",
    name: "recipient_name",
    defaultChecked: true,
    checked: true,
    search: true,
    sort: true,
    sort_Type: "",
    filter: {
      filterType: "input",
      filters: [
        { operation: "contains", value: "", selected: true, key: "name" },
      ],
    },
    options: {
      setCellProps: () => ({
        style: { maxWidth: "250px", whiteSpace: "nowrap" },
      }),
      customBodyRender: (value) => {
        return <ToolTipText value={value} />;
      },
    },
  },
  {
    label: "Recipient Email",
    value: "recipient_email",
    name: "recipient_email",
    defaultChecked: true,
    checked: true,
    search: true,
    sort: false,
    options: {
      sort: false,
      setCellProps: () => ({
        style: { maxWidth: "250px", whiteSpace: "nowrap" },
      }),
      customBodyRender: (value) => {
        return <ToolTipText value={value} />;
      },
    },
    filter: {
      filterType: "input",
      filters: [
        {
          operation: "is",
          value: "",
          selected: true,
          key: "emailId",
        },
      ],
    },
  },
  {
    label: "Recipient Phone",
    value: "recipient_phone",
    name: "recipient_phone",
    defaultChecked: true,
    checked: true,
    search: true,
    options: {
      sort: false,
      display: false,
    },
    filter: {
      filterType: "inputNumber",
      filters: [
        {
          operation: "is",
          value: "",
          selected: true,
          key: "phoneNumber",
        },
      ],
    },
  },
  {
    label: "Value of Link",
    value: "denomination_value",
    name: "denomination_value",
    defaultChecked: true,
    checked: true,
    search: false,
    options: {
      sort: false,
      setCellHeaderProps: () => ({
        className: "text-right",
        whiteSpace: "nowrap",
      }),
      setCellProps: () => ({ className: "text-right" }),
      customBodyRender: (value) => {
        return (
          <span
            style={{
              whiteSpace: "nowrap",
            }}
          >
            {value}
          </span>
        );
      },
    },
  },
  {
    label: "Sent Date (UTC)",
    value: "issued_date",
    name: "issued_date",
    defaultChecked: true,
    checked: true,
    search: false,
    sort: true,
    sort_Type: "desc",
    options: {
      customBodyRender: (value) => {
        return <Date value={value} />;
      },
    },
    filter: {
      filterType: "date",
      filters: {
        operation: "is between",
        startDate: moment().subtract(1, "month").format("YYYY-MM-DD"),
        endDate: moment().format("YYYY-MM-DD"),
        selected: true,
      },
    },
  },
  {
    label: "Redemption Date (UTC)",
    value: "redemption_date",
    name: "redemption_date",
    defaultChecked: false,
    checked: false,
    filter: {
      filterType: "date",
      filters: {
        operation: "is between",
        startDate: "",
        endDate: "",
        selected: true,
      },
    },
    options: {
      sort: false,
      display: false,
      customBodyRender: (value) => {
        return <Date value={value} />;
      },
    },
  },
  {
    label: "Expiry Date (UTC)",
    value: "issued_date",
    name: "expiry_date",
    defaultChecked: false,
    checked: false,
    search: false,
    options: {
      sort: false,
      display: false,
      customBodyRender: (value) => {
        return <Date value={value} />;
      },
    },
  },
  {
    label: "Redeemed By",
    value: "redemption_by",
    name: "redemption_by",
    defaultChecked: false,
    checked: false,
    options: {
      sort: false,
      display: false,
    },
  },
  {
    label: "Status",
    value: "redemption_status",
    name: "redemption_status",
    defaultChecked: true,
    checked: true,
    search: false,
    sort: true,
    sort_Type: "",
    options: {
      customBodyRender: (value, tableMeta, updateValue) => {
        return <StatusChip value={value} />;
      },
    },
    filter: {
      filterType: "select",
      filters: {
        value: "",
        options: XOXO_LINK_STATUS_SEND_TO_FEW,
        operation: "is",
      },
    },
  },
  {
    label: "Campaign",
    value: "campaignName",
    name: "campaignName",
    defaultChecked: false,
    checked: false,
    search: false,
    options: {
      display: false,
      sort: false,
    },
    filter: {
      filterType: "select",
      filters: {
        value: "",
        options: [],
        operation: "is",
      },
    },
  },
  {
    label: "Mode of Delivery",
    value: "delivery_method",
    name: "mode_of_delivery",
    defaultChecked: false,
    checked: false,
    options: {
      display: false,
      sort: false,
    },
  },
  {
    label: "Sent By",
    value: "sent_byemail",
    name: "sent_byemail",
    defaultChecked: false,
    checked: false,
    search: false,
    options: {
      sort: false,
      display: false,
    },
  },
  {
    label: "Batch ID",
    value: "batchId",
    name: "batchId",
    defaultChecked: true,
    checked: true,
    options: {
      sort: false,
    },
    filter: {
      filterType: "input",
      filters: [
        {
          operation: "is",
          value: "",
          selected: true,
          key: "batchId",
        },
      ],
    },
  },
  {
    label: "Xoxo Link",
    value: "xoxolink",
    name: "xoxolink",
    defaultChecked: false,
    checked: false,
    options: {
      sort: false,
      display: false,
    },
  },
  {
    label: "Notes",
    value: "notes",
    name: "notes",
    defaultChecked: false,
    checked: false,
    options: {
      sort: false,
      display: false,
      setCellProps: () => ({
        style: { maxWidth: "250px", whiteSpace: "nowrap" },
      }),
      customBodyRender: (value) => {
        return <ToolTipText value={value} />;
      },
    },
  },
  {
    name: "action",
    label: " ",
    defaultChecked: true,
    options: {
      sort: false,
    },
  },
];
